import { SanityFaqItem } from '@gelato-api-ui/core/sanity/sanity-faq-item';
import { SanityPrintAreas } from '@gelato-api-ui/core/sanity/sanity-print-areas';
import { SanityProductBadge } from '@gelato-api-ui/core/sanity/sanity-product-badge';
import { SanityProductFulfillment } from '@gelato-api-ui/core/sanity/sanity-product-fulfillment';
import { SanityProductPackaging } from '@gelato-api-ui/core/sanity/sanity-product-packaging';
import { SanityProductVariationSpecificContentItem } from '@gelato-api-ui/core/sanity/sanity-product-variation-specific-content-item';
import { ApparelExtraPrintAreaCode } from '../print-areas/constants/print-area-code';
import { PrintAreaName } from '../print-areas/constants/print-area-name';
import { SanityFileRequirements } from './sanity-file-requirements';
import { SanityProductAttribute } from './sanity-product-attribute';
import { SanityProductCareInstructions } from './sanity-product-care-instructions';
import { SanityProductControl } from './sanity-product-control';
import { SanityProductPages } from './sanity-product-pages';
import { SanityProductSimplified } from './sanity-product-simplified';
import { SanityProductVariation } from './sanity-product-variation';
import { SanitySizeGuide } from './sanity-size-guide';
import { GarmentTechnology } from './types/garment-technology.enum';

export interface SanityProduct {
  id: SanityProductId;
  title: string;
  subtitle: string;
  descriptionShort: string;
  description: string;
  material?: string;
  brands?: string;
  fulfilment?: SanityProductFulfillment;
  packaging?: SanityProductPackaging;
  faq?: SanityFaqItem[];
  sizeGuide?: SanitySizeGuide;
  printAreas?: SanityPrintAreas[];
  productUidForPrice?: string;
  productCareInstructions?: SanityProductCareInstructions;
  fileRequirements?: SanityFileRequirements[];
  productAttributes: SanityProductAttribute[];
  productImages: string[];
  productControls: SanityProductControl[];
  productVariations: SanityProductVariation[];
  pages?: SanityProductPages;
  similar: SanityProductSimplified[];
  productBadge?: SanityProductBadge;
  productFeatures?: ProductFeatures[];
  productTechnologies?: GarmentTechnology[];
  highlight?: SanityProductHighlight[];
  ecoCredentials?: string;
  fileSpecifications?: SanityProductFileSpecification[];
  videoId?: string;
  instructionSteps?: string[];
  instructionDetailsLink?: string;
  extraPrintAreas?: ApparelExtraPrintAreaCode[];
  isStockableProduct?: boolean;
  productVariationSpecificContent?: SanityProductVariationSpecificContentItem[];
}

export type SanityProductId = SanityProductEnum | string;
export enum SanityProductEnum {
  wallpaper = 'wallpaper',
  brandedInsert = 'product-branding-insert-title',
  brandedLabel = 'product-branding-label-title',
  standardPosters = 'standard-uncoated-paper-posters',
  standardFramedPosters = 'standard-uncoated-paper-framed-poster',
}

export interface SanityProductHighlight {
  bar?: SanityProductHighlightBarItem[];
  icon: string;
  text: string;
  title: string;
  productControlOptions: string[];
}

export interface SanityProductHighlightBarItem {
  leftTitle: string;
  rightTitle: string;
  score: number;
  title: string;
}

export interface SanityProductPrintAreaSpecificationItem {
  printArea: PrintAreaName;
  printAreaFile: string; // File url
}

export interface SanityProductFileSpecification {
  productControlOptions?: string[];
  areaSpecifications?: SanityProductFileSpecificationArea[];
}

export interface SanityProductFileSpecificationArea {
  printArea: string;
  printAreaFile: string;
  apparelSizes: string;
  printFileSize: string;
  printFileSizeInch: string;
}

export interface SanityProductFileSpecificationRow {
  cells: string[];
}

export enum ProductFeatures {
  embroidery = 'embroidery',
  mountedFramedPosters = 'mountedFramedPosters',
}
